import { jsx as l, jsxs as m } from "react/jsx-runtime";
import { forwardRef as v, useRef as g, useState as h, useEffect as u } from "react";
import d from "./styles.module.less.js";
const I = v(
  (t, f) => {
    var a;
    const i = g([]), n = t.options.findIndex(
      (e) => e.id === t.activeId
    ), [c, o] = h(0);
    return u(() => {
      var s;
      const e = (s = i.current[n]) == null ? void 0 : s.clientWidth;
      o(e);
    }, [n]), /* @__PURE__ */ l(
      "div",
      {
        ref: f,
        ...t.props,
        className: `${d.segmentedControl} ${(a = t.props) == null ? void 0 : a.className}`,
        children: /* @__PURE__ */ m("div", { className: d.segments, children: [
          /* @__PURE__ */ l(
            "div",
            {
              className: d.slidingBackground,
              style: {
                width: c,
                transform: `translateX(${c * n}px)`
              }
            }
          ),
          t.options.map((e, s) => /* @__PURE__ */ m(
            "div",
            {
              id: `segmented-control-${e.id}`,
              className: `${d.segment} ${t.activeId === e.id ? d.active : ""}`,
              onClick: () => !t.disabled && t.onChange(e.id),
              ref: (r) => {
                r && (i.current[s] = r);
              },
              children: [
                e.label,
                t.activeId === e.id && e.hoverIcon ? e.hoverIcon : e.icon
              ]
            },
            e.id
          ))
        ] })
      }
    );
  }
);
I.displayName = "SegmentedControl";
export {
  I as SegmentedControl
};
